import { render, staticRenderFns } from "./previewFormModal.vue?vue&type=template&id=1066d8ac&scoped=true"
import script from "./previewFormModal.vue?vue&type=script&lang=js"
export * from "./previewFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1066d8ac",
  null
  
)

export default component.exports